module.exports = __webpack_public_path__ + "img/icon6.fa772d90.png";